/**
 * Convenience method for adding event listeners that returns a subscription handle.
 */
export function listenFor(
    target: EventTarget,
    eventName: string,
    callback: EventListener,
    useCapture = false
) {
    target.addEventListener(eventName, callback, useCapture);

    return {
        unsubscribe: () => target.removeEventListener(eventName, callback, useCapture),
    };
}
